import React, { useEffect, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faCalendarXmark, faCalendarDay, faUserMd } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import { apiRaw } from '../../../api';

export default function CardsCantidad() {
    const [turnos, setTurnos] = useState([]);
    const [terapeutas, setTerapeutas] = useState([]);

    useEffect(() => {
        cargarTurnos();
        cargarTerapeutas();
    }, []);

    const cargarTurnos = () => {
        apiRaw(`/turnos`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTurnos(data.turnos || []);
            })
            .catch(error => console.error('Error al cargar turnos:', error));
    };

    const cargarTerapeutas = () => {
        apiRaw(`/usuarios`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTerapeutas(data.usuarios.filter(usuario => usuario.rol === "terapeuta") || []);
            })
            .catch(error => console.error('Error al cargar terapeutas:', error));
    };

    // Calcular indicadores
    const citasHoy = turnos.filter(turno => {
        const dias = JSON.parse(turno.dias);
        const hoy = new Date().toISOString().split('T')[0];
        return dias.some(dia => dia.dia === hoy);
    }).length;

    const citasPendientes = turnos.filter(turno => turno.estado === "Pendiente").length;
    
    const citasAsignadas = turnos.filter(turno => turno.estado === "Asignado").length;

    const promedioCitasPorTerapeuta = terapeutas.length > 0 
        ? (turnos.filter(turno => turno.idTerapeuta !== null).length / terapeutas.length).toFixed(1)
        : 0;

    return (
        <div className='CardsCantidad'>
            <Anchor to={`/dashboard/citas`} className='cardCantidad'>
                <FontAwesomeIcon icon={faCalendarDay} className='icons' />
                <div className='deColumn'>
                    <h3>Citas Hoy</h3>
                    <h2>{citasHoy}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/citas`} className='cardCantidad'>
                <FontAwesomeIcon icon={faCalendarCheck} className='icons' />
                <div className='deColumn'>
                    <h3>Citas Asignadas</h3>
                    <h2>{citasAsignadas}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/citas`} className='cardCantidad'>
                <FontAwesomeIcon icon={faCalendarXmark} className='icons' />
                <div className='deColumn'>
                    <h3>Citas Pendientes</h3>
                    <h2>{citasPendientes}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/citas`} className='cardCantidad'>
                <FontAwesomeIcon icon={faUserMd} className='icons' />
                <div className='deColumn'>
                    <h3>Citas por terapeuta</h3>
                    <h2>{promedioCitasPorTerapeuta}</h2>
                </div>
            </Anchor>
        </div>
    );
}
